"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = Dialog;
var _core = require("@blueprintjs/core");
var _classnames = _interopRequireDefault(require("classnames"));
var React = _interopRequireWildcard(require("react"));
var _buttonStyle = require("../../common/buttonStyle");
var _classes = require("../../common/classes");
var _size = require("../../common/size");
var _Button = require("../button/Button");
var _IconButton = require("../button/IconButton");
var _iconNames = require("../icon/iconNames");
var _typography = require("../typography/typography");
var _excluded = ["children", "className", "description", "large", "showCancelButton", "size", "small", "title"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function Dialog(_ref) {
  var children = _ref.children,
    className = _ref.className,
    description = _ref.description,
    large = _ref.large,
    showCancelButton = _ref.showCancelButton,
    size = _ref.size,
    small = _ref.small,
    title = _ref.title,
    dialogProps = _objectWithoutProperties(_ref, _excluded);
  var turbolinksFixPortalDocumentBody = document.body;

  /**
   * This exists to handle the fact that the `small` and `large` props have been replaced
   * by the `size` prop. We prioritize the size prop but still need to
   * take into account the deprecated ones
   */
  var sizeClassName = _classes.Classes.sizeClass(_size.Size.MEDIUM);
  if (size) {
    sizeClassName = _classes.Classes.sizeClass(size);
  } else if (small) {
    sizeClassName = _classes.Classes.sizeClass(_size.Size.SMALL);
  } else if (large) {
    sizeClassName = _classes.Classes.sizeClass(_size.Size.GIANT);
  }
  var classes = (0, _classnames.default)(sizeClassName, className);
  return /*#__PURE__*/React.createElement(_core.Dialog, _extends({
    canEscapeKeyClose: false,
    canOutsideClickClose: false
  }, dialogProps, {
    className: classes,
    portalContainer: turbolinksFixPortalDocumentBody
  }), /*#__PURE__*/React.createElement("div", {
    className: _classes.Classes.DIALOG_HEADER
  }, /*#__PURE__*/React.createElement(_typography.Heading4, {
    style: {
      marginTop: '4px'
    }
  }, title), /*#__PURE__*/React.createElement(_IconButton.IconButton40, {
    className: _classes.Classes.DIALOG_CLOSE_BUTTON,
    icon: _iconNames.IconNames16.CROSS_CIRCLE,
    "aria-label": "Close",
    onClick: dialogProps.onClose
  })), description && /*#__PURE__*/React.createElement(_typography.Lead, {
    muted: true,
    className: _classes.Classes.DIALOG_DESCRIPTION
  }, description), /*#__PURE__*/React.createElement("div", {
    className: _classes.Classes.DIALOG_BODY
  }, children, showCancelButton && /*#__PURE__*/React.createElement(_Button.Button, {
    fill: true,
    large: true,
    buttonStyle: _buttonStyle.ButtonStyle.TERTIARY,
    onClick: dialogProps.onClose,
    text: typeof showCancelButton === 'string' ? showCancelButton : 'Cancel'
  })));
}